<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  async mounted() {
    try {
      // cookie 认证：恢复登录态；与路由守卫共用 ensureUserInfo，避免重复请求
      await this.$store.dispatch('security/ensureUserInfo')
    } catch (e) {
      // 未登录或 cookie 失效时忽略
    }
  },
}
</script>

<style lang="less">
a {
  cursor: pointer;
  text-decoration: none;
}
</style>
